import { useState } from 'react';
import { useApi } from '@backstage/frontend-plugin-api';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { policyApiRef } from '../../api';
import { useStudioAccess } from '../../studio/useStudioAccess';

export function GroupObservationRefreshButton(props: {
  tenant: string;
  applicationGroupId: string;
}) {
  const { tenant, applicationGroupId } = props;
  const api = useApi(policyApiRef);
  const { access } = useStudioAccess(tenant, applicationGroupId);
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState('');

  if (access !== 'allowed') return null;

  const request = async () => {
    setPending(true);
    setMessage('');
    try {
      const result = await api.refreshGroupObservations(
        tenant,
        applicationGroupId,
      );
      setMessage(
        result.queued > 0
          ? `${result.queued} provider refresh job(s) queued. Quota values update after the jobs finish.`
          : 'No refresh was queued. Environments may already be refreshing or in the cooldown period.',
      );
    } catch (error) {
      setMessage(
        `Refresh could not be scheduled: ${
          error instanceof Error ? error.message : String(error)
        }`,
      );
    } finally {
      setPending(false);
    }
  };

  return (
    <>
      <Button disabled={pending} onClick={() => void request()}>
        {pending ? 'Requesting refresh…' : 'Refresh group inventory'}
      </Button>
      {message && (
        <Typography variant="body2" role="status">
          {message}
        </Typography>
      )}
    </>
  );
}
